export default "__VITE_ASSET__DEfzJ5F2__"